const moduleNameKey = "machineGroupsViewAdminPanel";

export const machineGroupsViewAdminPanelEn = {
  [moduleNameKey]: {
    title: "Machine Groups",
    description:
      "Define the path for ticket routing and machine access based on machine groups.",
    addGroupButton: "Add Group",
  },
};

export const machineGroupsViewAdminPanelPtBr = {
  [moduleNameKey]: {
    title: "Grupos de máquinas",
    description:
      "Defina o caminho para o direcionamento de chamados e o acesso às máquinas com base nos grupos de máquinas.",
    addGroupButton: "Adicionar grupo",
  },
};

export const machineGroupsViewAdminPanelDe = {
  [moduleNameKey]: {
    title: "Maschinengruppen",
    description:
      "Definieren Sie den Pfad für die Ticketweiterleitung und den Maschinenzugriff auf Grundlage von Maschinengruppen.",
    addGroupButton: "Gruppe hinzufügen",
  },
};

export const machineGroupsViewAdminPanelZhHans = {
  [moduleNameKey]: {
    title: "机器组",
    description: "根据机器组定义工单路由和机器访问路径。",
    addGroupButton: "添加组",
  },
};

export const machineGroupsViewAdminPanelIt = {
  [moduleNameKey]: {
    title: "Gruppi di macchine",
    description:
      "Definisci il percorso per l'instradamento dei ticket e l'accesso alle macchine in base ai gruppi di macchine.",
    addGroupButton: "Aggiungi gruppo",
  },
};

export const machineGroupsViewAdminPanelEs = {
  [moduleNameKey]: {
    title: "Grupos de máquinas",
    description:
      "Define la ruta para el enrutamiento de tickets y el acceso a las máquinas según los grupos de máquinas.",
    addGroupButton: "Añadir grupo",
  },
};

export const machineGroupsViewAdminPanelNl = {
  [moduleNameKey]: {
    title: "Machinegroepen",
    description:
      "Definieer het pad voor ticketroutering en machinetoegang op basis van machinegroepen.",
    addGroupButton: "Groep toevoegen",
  },
};

export const machineGroupsViewAdminPanelTr = {
  [moduleNameKey]: {
    title: "Makine Grupları",
    description:
      "Makine gruplarına göre destek bileti yönlendirme ve makine erişim yolunu tanımlayın.",
    addGroupButton: "Grup Ekle",
  },
};
